/**
 * @owner @Appboy/messaging-experience
 */
import type { SelectableMessageType } from "@lib/campaignMessageTypeConstants";

import { isPrioritizableChannelSelection } from "./isPrioritizableChannelSelection";
import type { FeatureOn, MessagePrioritizationIneligibleReason } from "./types";

/**
 * Classifies why a channel selection cannot use Message Prioritization.
 * Multichannel wins over a single ineligible channel so the UI shows one warning.
 *
 * @param types - Currently selected message types on the step.
 * @param featureOn - a `featureOn` checker (`useFeatureOn()` or `@lib/featureFlipper`)
 * @returns `undefined` when the selection is prioritizable.
 */
export const getMessagePrioritizationIneligibleReason = (
  types: readonly SelectableMessageType[],
  featureOn: FeatureOn
): MessagePrioritizationIneligibleReason | undefined => {
  if (isPrioritizableChannelSelection(types, featureOn)) {
    return undefined;
  }
  if (types.length > 1) {
    return "multichannel";
  }
  return "channelIneligible";
};
